module.exports = __webpack_public_path__ + "img/extended.ba030df2.png";